/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/css/global.css"
import "./src/css/font-awesome/all.css"
import "./src/css/custom.css"
